import { Service } from '@piwikpro/platform';

@Service()
export class PaymentRequiredError extends Error {
  name = 'PaymentRequiredError';
}
